
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Origine dati',
	'dataSourceId': 'Id',
	'dataSourceType': 'Tipo',
	'dataSourceName': 'Nome',
	'dataSourcePath': 'Percorso',
	'showInfoForAll': 'Mostra durata per tutte le visualizzazioni',
	'hideInfoForAll': 'Nascondi la durata per tutte le visualizzazioni',
	'showPerformanceDetails': 'Riesegui tutti i widget per includere i dettagli sulle prestazioni',
	'slotMappingField': 'Associazioni slot',
	'slotDataMapping': 'Mappatura',
	'slotID': 'ID',
	'slotCaption': 'Didascalia',
	'slotMandatory': 'Obbligatorio',
	'slotIsMandatory': 'Sì',
	'slotIsNotMandatory': 'No',
	'infoNotAvailable': 'Non disponibile',
	'performanceSection': 'Prestazione',
	'durationField': 'Durata',
	'singleQueryTime': 'Query del server (ms)',
	'multipleQueryTime': 'Query del server %{name} (ms)',
	'liveWidgetTotalTime': 'Totale (ms)',
	'renderTimeNotAvailable': 'Non disponibile',
	'renderInProgress': '(in avanzamento)',
	'interactToTriggerQuery': 'Interagisci con il widget per attivare una query',
	'fetchQuery': 'Richiamo query',
	'showSQLMDX': 'Mostra SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informazioni di query',
	'queryInfoNotAvailable': 'Informazioni di query non disponibili',
	'query': 'Query',
	'copy': 'Copia',
	'close': 'Chiudi'
});
